import { render, staticRenderFns } from "./campaign-email-creation.vue?vue&type=template&id=01242d1e"
import script from "./campaign-email-creation.vue?vue&type=script&lang=js"
export * from "./campaign-email-creation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports